<select (change)="selectFilter($event)" [(ngModel)]="typeFilte" class="form-select form-select" aria-label=".form-select-sm example">
    <option value="">Selecciona filtro:</option>
    <option *ngFor="let tFilter of ltsFilterGet" value="{{tFilter.Id}}">
        {{tFilter.Value}}
    </option>
</select>